export default __webpack_public_path__ + "static/media/06-1.bfb36e0e.jpg";